import React from "react";
import { useTable, usePagination, useFilters } from "react-table";

const Table = ({ columns, data }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useFilters,
    usePagination
  );

  return (
    <table {...getTableProps()} className="table table-hover">
      <thead>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column, index) => (
              <th key={index} scope="col">
                {column.label}
                {column.render("Header")}
                {/*<div>{column.canFilter ? column.render('Filter') : null}</div>*/}

                <div></div>
              </th>
            ))}
          </tr>
        ))}
      </thead>

      <tbody {...getTableBodyProps()}>
        {page.map((row, i) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map((cell) => {
                return (
                  <td key={cell.column.id} {...cell.getCellProps()}>
                    {cell.render("Cell")}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
      <tfoot>
        <tr>
          <td colSpan={columns.length}>
            <button onClick={() => previousPage()} hidden={!canPreviousPage}>
              Pagina prec.
            </button>
            <button onClick={() => nextPage()} hidden={!canNextPage}>
              Pagina succ.
            </button>
          </td>
        </tr>
      </tfoot>
    </table>
  );
};

export default Table;
